import { Button } from '@design-system/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@design-system/tooltip';
import { Calendar, ClipboardText, ReceiptItem, TagUser } from 'iconsax-react';
import type { FC } from 'react';

interface TAddonPlan {
  id: number;
  title: string;
  description: string;
  price: string;
  features: {
    applications: number;
    invoices: number;
    leads: number;
    appointments: number;
  };
}

const AddonCard: FC<{ plan: TAddonPlan }> = ({ plan }) => {
  return (
    <div className='relative mt-7 h-full'>
      <div
        className={`w-full h-full flex flex-col gap-4 bg-white rounded-xl py-8 px-4 border border-primary-200 text-center rel`}
      >
        <h2 className='text-2xl font-bold text-primary-1000 text-center uppercase'>
          {plan.title}
        </h2>
        <p className='text-gray-800 text-base font-normal mb-5 h-9'>
          {plan.description}
        </p>
        <div>
          <p className='text-gray-800 font-semibold text-5xl'>
            <span className='text-gray-600 font-normal text-lg'>$</span>
            {plan.price}
          </p>
        </div>
        <p className='text-gray-600 font-normal text-sm flex justify-center gap-2'>
          <span>Price/Org/Month Billed Monthly</span>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className='rounded-full border-gray-600 border w-5 h-5 cursor-pointer'>
                ?
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <span className='text-gray-900 text-sm font-medium'>
                Pay Upfront - Commit Annually
              </span>
            </TooltipContent>
          </Tooltip>
        </p>
        <div className='flex flex-col items-center mt-3'>
          <Button
            variant='ghost'
            className='w-full border-primary-1000 linear border text-primary-1000'
          >
            Add-On
          </Button>
        </div>
        <ul className='list-disc text-gray-800 text-start mt-4 font-normal'>
          <li className='flex items-center gap-2 mb-4'>
            <ClipboardText
              size='24'
              color='#584777'
              variant='Bulk'
            />
            <span className='font-normal text-gray-800 text-base'>
              {plan.features.applications} Applications
            </span>
          </li>
          <li className='flex items-center gap-2 mb-4'>
            <ReceiptItem
              size='24'
              color='#584777'
              variant='Bulk'
            />
            <span className='font-normal text-gray-800 text-base'>
              {plan.features.invoices} Invoices
            </span>
          </li>
          <li className='flex items-center gap-2 mb-4'>
            <TagUser
              size='24'
              color='#584777'
              variant='Bulk'
            />
            <span className='font-normal text-gray-800 text-base'>
              {plan.features.leads} Leads
            </span>
          </li>
          <li className='flex items-center gap-2'>
            <Calendar
              size='24'
              color='#584777'
              variant='Bulk'
            />
            <span className='font-normal text-gray-800 text-base'>
              {plan.features.appointments} Appointments
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AddonCard;
